module.exports = __webpack_public_path__ + "img/btc.f92890de.svg";